<template>
<main-content>
    <rejected_status_description></rejected_status_description>
    <kt-row v-if="!$can('manage', 'all')">
        <div class="col-lg-6 col-md-6 col-sm-6">
            <balance :balance="dashboard.balance"/>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6">
            <transactions :transaction="dashboard.transaction"/>
        </div>
    </kt-row>

    <kt-row>
        <div v-if="$can('read', 'transaction')" class="col-lg-4 col-md-4 col-sm-6">
            <transactions :transaction="dashboard.transaction"/>
        </div>
        <div v-if="$can('read', 'transaction')" class="col-lg-4 col-md-4 col-sm-6">
            <settlements :settlement="dashboard.settlement"/>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6" v-if="$can('read', 'ticket')">
            <kt-row>
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <tickets :ticket="dashboard.ticket"/>
                </div>
            </kt-row>
        </div>
    </kt-row>

    <kt-row v-if="$can('read-sensitive-info', 'user')">
        <div class="col-lg-3 col-md-3 col-sm-6">
            <user-compo
                    :user_data="dashboard.user.terminalless"
                    :title="$t('dashboard.label.terminalless_users')"
            />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
            <user-compo
                    :user_data="dashboard.user.not_verified"
                    :title="$t('dashboard.label.documentless_users')"
            />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
            <user-compo
                    :user_data="dashboard.user.pending"
                    :title="$t('dashboard.label.pending_users')"
            />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
            <user-compo
                    :user_data="dashboard.user.total"
                    :title="$t('dashboard.label.total_users')"
            />
        </div>
    </kt-row>

    <kt-row v-if="$can('read-statistics', 'transaction')">
        <div class="col-lg-4 col-md-4 col-sm-6">
            <daily-profit :profit="dashboard.profit"/>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6">
            <monthly-profit :profit="dashboard.profit"/>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6">
            <total-profit :profit="dashboard.profit"/>
        </div>
    </kt-row>

    <kt-row>
        <div class="col-lg-12 col-md-12 col-sm-12">
            <monthly-transaction-chart :chart_data="dashboard.chart_data"/>
        </div>
    </kt-row>

    <kt-row>
        <div class="col-lg-12 col-md-12 col-sm-12">
            <login-log :login_log="dashboard.login_log"/>
        </div>
    </kt-row>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {
    loginLog,
    settlements,
    tickets,
    userCompo,
    balance,
    transactions,
    dailyProfit,
    monthlyProfit,
    totalProfit,
    monthlyTransactionChart,
    rejectedStatusDescription
} from "./dashboard";
import {mapGetters} from "vuex";

export default {
    name: 'home',
    components: {
        'main-content': mainContent,
        'login-log': loginLog,
        'settlements': settlements,
        'tickets': tickets,
        'user-compo': userCompo,
        'balance': balance,
        'transactions': transactions,
        'daily-profit': dailyProfit,
        'monthly-profit': monthlyProfit,
        'total-profit': totalProfit,
        'monthly-transaction-chart': monthlyTransactionChart,
        'rejected_status_description': rejectedStatusDescription,
    },
    mounted() {
        this.$store.dispatch('dashboard/fetchDashboard')
    },
    computed: {
        ...mapGetters('dashboard', [
            'dashboard'
        ])
    }
}
</script>

<style>
    .kt-portlet .kt-portlet__body {
        padding: 15px !important;
    }
    .fix-margin {
        margin-bottom: 0 !important;
        margin-top: .75rem !important;
    }
</style>